import moment from 'moment'
import momentTZ from 'moment-timezone'

import {
  getRing,
  getUpcomingDeliveries
} from 'src/modules/MyDeliveries/selectors'
import { getUserDeliveryInfo } from 'src/modules/MyAccount/components/Settings/selectors'

export function getPauseResumeData(state, unpauseDate: string | null) {
  if (!unpauseDate) {
    return
  }
  const upcomingDeliveries = getUpcomingDeliveries(state)

  const orderByDate = upcomingDeliveries.find(
    delivery => moment(delivery.displayDate) >= moment(unpauseDate)
  )

  if (!orderByDate) {
    const ring = getRing(state)
    const userDeliveryInfo = getUserDeliveryInfo(state)
    const userTimeZone =
      upcomingDeliveries && upcomingDeliveries[0]?.cutoff.userTimeZone
    const userDeliveryDay = userDeliveryInfo?.selectedDeliveryDays[0].day

    return calculatePauseResumeData({
      unpauseDate,
      userDeliveryDay,
      shippingDays: Number(ring.shipping_days),
      userTimeZone
    })
  }

  const cutoffDate = moment(orderByDate.cutoff.time).format('MM/DD/YY')

  const [zone, , time] = momentTZ(orderByDate.cutoff.time)
    .tz(orderByDate.cutoff.userTimeZone)
    .zoneAbbr()
    .split('')

  return {
    displayDate: orderByDate.displayDate,
    cutoff: {
      date: cutoffDate,
      userTimezone: `${zone}${time}`
    }
  }
}

function calculatePauseResumeData({
  unpauseDate,
  userDeliveryDay,
  shippingDays,
  userTimeZone
}) {
  const daysToDelivery = getDaysToDelivery({
    userDeliveryDay,
    unpauseDate
  })
  const resumeDate = moment(unpauseDate)
    .add(daysToDelivery, 'days')
    .format('MM/DD/YY')

  const cutoffDate = moment(resumeDate)
    .subtract(4 + shippingDays, 'days')
    .format('MM/DD/YY')

  const [zone, , time] = userTimeZone
    ? momentTZ()
        .tz(userTimeZone)
        .zoneAbbr()
        .split('')
    : ['', '', '']

  return {
    displayDate: resumeDate,
    cutoff: {
      date: cutoffDate,
      userTimezone: `${zone}${time}`
    }
  }
}

function getDaysToDelivery({
  userDeliveryDay,
  unpauseDate
}: {
  userDeliveryDay: number
  unpauseDate: string
}) {
  const unpauseDateNumber = moment(unpauseDate).isoWeekday()
  // How many days from unpause date to next delivery?
  const daysToAdd = (userDeliveryDay - unpauseDateNumber + 7) % 7
  return daysToAdd === 0 ? 7 : daysToAdd
}
